function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M49.8752 69.5524L40.1992 55.4844",
  stroke: "#3370FF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M42.6685 81.9957L26.1465 78.7217",
  stroke: "#3370FF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M45.9673 75.7164L39.2773 69.0784",
  stroke: "#3370FF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M93.6504 178.853H177.012",
  stroke: "#3370FF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M138.111 107.511L148.663 86.4134C156.453 70.8354 150.081 51.7174 134.505 43.9254C118.927 36.1354 99.8069 42.5054 92.0149 58.0834L81.4629 79.1814",
  fill: "white"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M68.4462 70.3629C69.0702 71.5089 70.0362 72.4829 71.2922 73.1089C74.5562 74.7409 78.5222 73.4189 80.1542 70.1569L90.7062 49.059C93.6862 43.103 98.8362 38.653 105.212 36.5269C111.586 34.403 118.376 34.8749 124.332 37.8529C130.29 40.8289 134.744 45.9809 136.862 52.3569C138.986 58.7329 138.516 65.5229 135.538 71.479L124.988 92.577C123.352 95.841 124.68 99.811 127.94 101.439C131.204 103.071 135.172 101.749 136.802 98.4869L147.354 77.389C151.91 68.2749 152.636 57.903 149.398 48.181C146.154 38.459 139.354 30.5929 130.24 26.0369C121.13 21.4809 110.756 20.7549 101.034 23.9929C91.3122 27.2349 83.4482 34.0369 78.8902 43.1509L68.3382 64.2469C67.3362 66.2549 67.4502 68.5309 68.4462 70.3629Z",
  fill: "#DFEAFF"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M143.93 83.1909C148.488 74.0769 149.212 63.7049 145.972 53.9829C142.732 44.2589 135.93 36.3949 126.816 31.8389C117.706 27.2809 107.332 26.5569 97.6104 29.7969C87.8884 33.0369 80.0244 39.8389 75.4664 48.9509L64.9144 70.0489C63.9124 72.0569 64.0264 74.3309 65.0224 76.1629C65.6464 77.3109 66.6144 78.2849 67.8684 78.9109C71.1324 80.5429 75.0984 79.2229 76.7304 75.9589L87.2824 54.8609C90.2624 48.9029 95.4124 44.4549 101.788 42.3289C108.162 40.2069 114.952 40.6749 120.908 43.6549C126.866 46.6329 131.32 51.7829 133.438 58.1589C135.562 64.5329 135.092 71.3229 132.114 77.2809L121.562 98.3789C119.928 101.645 121.256 105.613 124.516 107.241C127.78 108.873 131.748 107.551 133.378 104.289",
  stroke: "#3370FF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M45.2681 101.966L30.0461 119.988C18.8061 133.292 20.4941 153.374 33.8001 164.614C47.1061 175.854 67.1881 174.166 78.4281 160.86L93.6501 142.84",
  fill: "white"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M45.2681 101.966L30.0461 119.988C18.8061 133.292 20.4941 153.374 33.8001 164.614C47.1061 175.854 67.1881 174.166 78.4281 160.86L93.6501 142.84",
  stroke: "#3370FF",
  strokeWidth: 13.21,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M101.499 84.478L62.3672 130.8L101.499 84.478Z",
  fill: "#FFC102"
});
var _ref12 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M55.984 132.506C56.32 133.768 57.03 134.942 58.102 135.846C60.89 138.202 65.056 137.852 67.41 135.064L106.544 88.7397C108.9 85.9497 108.54 81.7817 105.762 79.4317C102.974 77.0777 98.808 77.4277 96.452 80.2137L57.32 126.538C55.87 128.254 55.446 130.49 55.984 132.506Z",
  fill: "#FFC60A"
});
var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M105.225 119.4C105.225 119.4 126.323 140.398 131.783 177.096C131.783 177.096 135.027 163.076 141.879 161.152",
  stroke: "#3370FF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref14 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M157.244 119.441C145.67 118.765 135.74 127.599 135.064 139.173C134.388 150.747 143.222 160.677 154.796 161.353C166.37 162.029 176.302 153.195 176.978 141.621C177.654 130.047 168.818 120.117 157.244 119.441Z",
  fill: "#F54A45"
});
var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M165.231 150.749L146.809 130.043",
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M166.374 131.187L145.668 149.607",
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var SvgMobileQuestionnaireExpired = function SvgMobileQuestionnaireExpired(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMobileQuestionnaireExpired, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mobile_questionnaire_expired.8276e759.svg";
export { ForwardRef as ReactComponent };